import { render, staticRenderFns } from "./PersonnelAdd.vue?vue&type=template&id=1f98c75f&scoped=true"
import script from "./PersonnelAdd.vue?vue&type=script&lang=js"
export * from "./PersonnelAdd.vue?vue&type=script&lang=js"
import style0 from "./PersonnelAdd.vue?vue&type=style&index=0&id=1f98c75f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98c75f",
  null
  
)

export default component.exports